import {IArenaGameFiltersCategory} from "../arena-filters/arena-game-filters-category.interface";
import {IFilterCategoryDefinition} from "../interfaces/filter-category-definition.interface";
import {IGameFilterDefinition} from "../interfaces/game-filter-definition.interface";
import {OtherFilter} from "../filters-definitions/other.filter";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {GameInfo} from "../../games/game-info";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";


export class OtherFiltersCategory implements IFilterCategoryDefinition {

    constructor(otherAvailableCategories: IArenaGameFiltersCategory[], private readonly services: IServiceFactoryExtended) {
        this.availableFilters = [
            new OtherFilter(otherAvailableCategories)
        ];
    }

    applyFilters(gameInfo: GameInfo, filters: IGameFilterDefinition[]): ApplyGameFilterResult {
        return this.availableFilters[0].applyFilter(gameInfo);
    }

    readonly title: string = "Others";
    readonly availableFilters: IGameFilterDefinition[];
}